import * as dom from './lib/dom.js';

export default function() {
    const is_home = document.querySelector('.home');
    const windowWidth = window.innerWidth;
    // if(windowWidth < 767){ return; }
    if(!is_home){ return }

    window.addEventListener('load', function() {
        const cardBtns = document.querySelectorAll('.js-home-podcasts-show-card');
        dom.forEachEl(cardBtns, (card) => {
            card.addEventListener('click', (e) => {
                e.preventDefault();
                const index = card.getAttribute('data-index');
                const tabEquivalent = document.querySelector(`.js-home-podcasts-show-tab[data-index='${index}']`)
                
                dom.removeClass(document.querySelector('.js-home-podcasts-show-card.active'), 'active');
                dom.removeClass(document.querySelector('.js-home-podcasts-show-tab.active'), 'active');
                dom.addClass(card, 'active');
                dom.addClass(tabEquivalent, 'active');
                
            });
        });
    });
}